export * from './StaticContent';


// WEBPACK FOOTER //
// ./src/components/Footer Section/index.js